import React from "react";
import { Grid, Box } from "@mui/material";
import ServiceCard from "./ServiceCard";

const ServiceList = ({ services = [], branchDetail, isBusy }) => {
  console.log("Services in ServiceList:", services);
  return (
    <Grid item xs={12}>
      <Box p={2}>
        <ServiceCard
          services={services}
          branchDetail={branchDetail}
          isBusy={isBusy}
        />
      </Box>
    </Grid>
  );
};

export default ServiceList;